export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCzh6oA2xE7GiohLX-3Ew8fF4EjUE8qiss',
    authDomain: 'nanofinans-3a395.firebaseapp.com',
    databaseURL: 'https://nanofinans-3a395.firebaseio.com',
    projectId: 'nanofinans-3a395',
    storageBucket: 'nanofinans-3a395.appspot.com',
    messagingSenderId: '594404199465'
  }
};
